(function($, global) {

	// requestAnimationFrame polyfill 
	// - https://gist.github.com/paulirish/1579671
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
 
	if (!window.requestAnimationFrame){
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { 
				callback(currTime + timeToCall); 
			}, timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}

  if (!window.cancelAnimationFrame) {
  	window.cancelAnimationFrame = function(id) {
  		clearTimeout(id);
  	};
  }
  // end polyfill

	$(document).ready( function() {
		foodly.cacheSelectors();
		foodly.coverImg('.js-img-holder-cover');
		foodly.init();
	});

	$(window).load( function(){
		$('.content-wrapper').css({
			'overflow': 'hidden'
		});

		foodly.parallaxScroll('.parallax');
	});

	var foodly = {
		cacheSelectors: function() {
			this.cache = {
				$body : $('body'),
				$cart : $('#cart'),
				$header: $('.header'),
				modalScroll : [],
				$parallax: $('.parallax'),
				$parallaxBack: $('.parallax__back'),
				$parallaxBase: $('.parallax__base'),
				$header: $('.header'),
			};

			this.DOM = {};
			this.DOM.mainContent  = document.querySelector('.main-content');	
			this.DOM.header       = document.querySelector('.header');
			this.DOM.parallaxBack = document.querySelector('.parallax__back');

			this.scrollBarWidth  = this.getScrollBarWidth();
		},

		init: function() {
			this.updateDropdownCart();
			this.initHeader();
			this.initAddToCard('form[action*="cart/add"]');
			this.initChangeQuantity('form[action*="cart"]');
			this.initUpdateCartAjax();
			this.initRecoverPasswordForm('.login-form');
			this.initFormsError();
			this.showTopBar('.fixed-bar');
			this.initDropdown('.js-dropdown');
			
			this.initModalAddresses();
			this.initDropdownScroll('.js-dropdown-scroll');
			this.foldElements('.fold');
			this.showHideMaps('.map-wrapper');
			this.initToolbar('.collection__toolbar');
			this.initAddToWishlist('.js-wishlist-form');
			this.initActionsWishlist('.js-wishlist');
			this.initDropdownAfterChanageSelector('#address_country', '#address_province');
			this.initDropdownAfterChanageSelector('#AddressCountryNew', '#AddressProvinceNew');
			this.initDropdownAfterChanageSelector('.AddressCountry', '.AddressProvince');
			this.initUtils();
		},

		// Initialization of functions for header
		initHeader: function() {

			this.initNavDrawer();
			this.initCartDrawer();

			document.body.addEventListener('drawer-open', function(){
	      document.body.classList.add('overflow-hidden');
	      this.DOM.mainContent.style.paddingRight  = this.scrollBarWidth + 'px';
	      this.DOM.header.style.paddingRight       = this.scrollBarWidth + 'px';
	      if (this.DOM.parallaxBack) {
	      	this.DOM.parallaxBack.style.paddingRight = this.scrollBarWidth + 'px';	      	
	      }
	    }.bind(this));

	    document.body.addEventListener('drawer-closed', function(){
	      document.body.classList.remove('overflow-hidden');
	      this.DOM.mainContent.style.paddingRight  = '';	      
	      this.DOM.header.style.paddingRight       = '';
	      if (this.DOM.parallaxBack) {
	      	this.DOM.parallaxBack.style.paddingRight = '';	      	
	      }
	    }.bind(this));


			// Collapsing for mobile menu items
			this.initCollapsing('.has-dropdown > a');

			// Opening search field by clicking on icon
			this.searchHeaderToggle();

			// Fixed header
			this.fixedHeader('.header');

			// Closing dropdowns and search container by clicking on other elements
			this.cache.$body.mousedown(function(e) {
				$target = $(e.target);

				$parentTargetDropdown = $target.closest('.dropdown');
				$openDropdown = $('.dropdown.open');

				$parentTargetSearch = $target.closest('.search-container');
				$openSearch = $('.search-container.open');

				if ( $parentTargetDropdown.length === 0 && $openDropdown.length > 0 ) {
					$openDropdown.removeClass('open');
				} else if ( $parentTargetSearch .length === 0 && $openSearch.length > 0 ) {
					$openSearch.removeClass('open');
					$openSearch.children().removeClass('popup-active');
				}
			});
		},

		initNavDrawer: function() {

	    this.DOM.mainNav = document.getElementById('main-nav');

	    if (!this.DOM.mainNav ) {
	    	return null;
	    }

	    var overlay = this.getOverlay();

			this.DOM.mainNavBtnOpen  = document.getElementById('main-nav-open-btn');
			this.DOM.mainNavBtnClose = this.DOM.mainNav.querySelector('.drawer__btn-close');

			this.DOM.mainNav.appendChild(overlay);

	    this.DOM.mainNavBtnOpen.addEventListener('click', function(){
	      this.openDrawer(this.DOM.mainNav);
	    }.bind(this));

	    this.DOM.mainNavBtnClose.addEventListener('click', function(){
	      this.closeDrawer(this.DOM.mainNav);
	    }.bind(this));

	    document.body.addEventListener('overlay-clicked', function(){
	      this.closeDrawer(this.DOM.mainNav);
	    }.bind(this));
		},

		initCartDrawer: function() {

	    this.DOM.cart = document.querySelector('.drawer--cart');

	    if (!this.DOM.cart ) {
	    	return null;
	    }

	    var overlay = this.getOverlay();

	    this.DOM.cartBtnOpen    = document.getElementById('cart-open-btn');
			this.DOM.cartBtnClose   = this.DOM.cart.querySelector('.drawer__btn-close');

			this.DOM.cart.appendChild(overlay);

	    this.DOM.cartBtnOpen.addEventListener('click', function(){

				if ( $(window).scrollTop() > 0 ) {
					$('html, body').animate({
						scrollTop: 0
					}, 1000, function(){
						setTimeout(function(){
							this.openDrawer(this.DOM.cart);
						}.bind(this), 300);
					}.bind(this));
				} else {
					this.openDrawer(this.DOM.cart);
				}

	    }.bind(this));

	    this.DOM.cartBtnClose.addEventListener('click', function(){
	      this.closeDrawer(this.DOM.cart);
	    }.bind(this));

	    document.body.addEventListener('overlay-clicked', function(){
	      this.closeDrawer(this.DOM.cart);
	    }.bind(this));
		},

		openDrawer: function(drawer) {
	    if (drawer.classList.contains('close')) {        
	      drawer.classList.add('open');
	      drawer.classList.remove('close');
	    }

	    this.triggerEvent(document.body, 'drawer-open');
	  },

	  closeDrawer: function(drawer) {
	    if (drawer.classList.contains('open')) {        
	      drawer.classList.add('close');
	      drawer.classList.remove('open');
	    }

	    this.triggerEvent(document.body, 'drawer-closed');		
	  },

	  triggerEvent: function(element, eventName, eventInit) {

	  	if (!eventName) {
	  		return null;
	  	}

	  	var event;

		  event = new CustomEvent(eventName, eventInit);
		  element.dispatchEvent(event);
	  },

	  getOverlay: function() {
	  	// Add overlay for drawers
			var overlay = document.createElement('div');

			overlay.className = 'overlay';

			overlay.addEventListener('click', function(){
				this.triggerEvent(document.body, 'overlay-clicked');
			}.bind(this));

			return overlay;
	  },

	  getScrollBarWidth: function() {
		  var inner = document.createElement('p');
		  inner.style.width = "100%";
		  inner.style.height = "200px";

		  var outer = document.createElement('div');
		  outer.style.position = "absolute";
		  outer.style.top = "0px";
		  outer.style.left = "0px";
		  outer.style.visibility = "hidden";
		  outer.style.width = "200px";
		  outer.style.height = "150px";
		  outer.style.overflow = "hidden";
		  outer.appendChild (inner);

		  document.body.appendChild (outer);
		  var w1 = inner.offsetWidth;
		  outer.style.overflow = 'scroll';
		  var w2 = inner.offsetWidth;
		  if (w1 == w2) w2 = outer.clientWidth;

		  document.body.removeChild (outer);

		  return (w1 - w2);
		},

		// Collapsing menu items in mobile view
		initCollapsing: function(toggleClass) {
			var toggleForCollapsing = document.querySelectorAll(toggleClass);
		
			if ( toggleForCollapsing.length <= 0 ) {
				return null;
			}

			for (var i = 0, max = toggleForCollapsing.length; i < max; i++) {
				toggleForCollapsing[i].addEventListener('click', function(e) {

					var windowSize = window.getComputedStyle(document.body,':after').getPropertyValue('content');

					if (windowSize.indexOf("widescreen") >= 0) {
					  return null;
					};
					
					e.preventDefault();

					var collapsingContainer = e.currentTarget.parentElement;

					if (collapsingContainer.classList.contains('show-dropdown')) {
						collapsingContainer.classList.remove('show-dropdown');
					} else {
						collapsingContainer.classList.add('show-dropdown');
					}
				});
			}
		},

		// Open search field after click on search icon in the header
		searchHeaderToggle: function() {
			var $searchContainer = $('.search-container');
			var $searchToggle = $searchContainer.find('.js-icon--search');
			var $searchForm = $searchContainer.find('form[action="/search"]');

			$searchToggle.click(function(){
				if ( $searchContainer.hasClass('open') ) {
					$searchForm.submit();
				} else {
					$searchForm.find('input[name="q"]').focus();
					$searchContainer.addClass('open');
				}
			});
		},

		// Open search field after click on search icon in the header
		searchHeaderToggleFull: function() {

			var $searchContainer, $searchToggle, bg;
			$searchContainer = $('.search-container');
			$searchToggle    = $searchContainer.find('.js-icon--search');
			bg = $searchContainer.find('.search-container-bg');

			if (bg.length <= 0) {
				bg = $('<span/>').addClass('search-container-bg').appendTo($searchContainer);
			}

			$searchToggle.click(function(e){

				bg.css({
					'top':  e.pageX,
					'left': e.pageY
				});

				$searchContainer.addClass('open-full');
			});
		},
		
		// Add to cart (click on button "Add to cart")
		initAddToCard: function(forms) {

			var $forms = $(forms);
	
			if ( $forms.length === 0 || $forms.hasClass('js-form-disable')){
				return null;
			}

			var $this = this;
            var $quantityField;
          
          if ( $forms.hasClass('js-form-cart-alt') ) {
            $quantityField = $forms.find('.quantity-field');
            
            $quantityField.on('click', function(e){
              var $productVisual = $(this).closest('.product-in-cart');
              var target         = e.target;
              var currentTarget  = e.currentTarget;
              var quantityConter = currentTarget.querySelector('.quantity__counter');
              var quantity       = parseInt(quantityConter.innerHTML);
              var variantId      = $productVisual.find('input[name=id]').val();
              
              if ( target.classList.contains('js-down-quantity') || target.parentElement.classList.contains('js-down-quantity') ){
                
                quantity--;
              } else if ( target.classList.contains('js-up-quantity') || target.parentElement.classList.contains('js-up-quantity') ) {
                
                quantity++;
              } else {
                return null;
              }
              
              if ( quantity <= 0 ) {
                $productVisual.removeClass('product-in-cart');
              } else {
              	quantityConter.innerHTML = quantity;
              }
              
              $.ajax({
								type: "post",
								url: "/cart/update.js",
								data: 'updates[' + variantId + ']=' + quantity,
								dataType: 'json',
								success: function(data) {
									$this.doUpdateDropdownCart(data, false);
								}
							});

            });
            
            $forms.submit( function(e) {
							e.preventDefault();
			        $(this).closest('.product__visuals').addClass('product-in-cart');

							// Ajax update of shopping cart
							$this.doAjaxAddToCart($(this));
						});
          
          } else {
            $forms.submit( function(e) {
							e.preventDefault();

							// Ajax update of shopping cart
							$this.doAjaxAddToCart($(this));
						});
          }

		},

		// Sending Ajax query to update shopping cart
		doAjaxAddToCart: function($form) {

			if ( $form.hasClass('wishlist-add-cart') ) {
				var $elementForInsert = $('.table-wrapper');
			} else {
				var $elementForInsert = $form.find('.js-add-to-card');
			}

			var data = $form.serialize();

			$.ajax({
				type: "post",
				url: "/cart/add.js",
				data: data,
				dataType: 'json',
				beforeSend: function() {
					// Show loading spiner on button
					if ( !$form.hasClass('js-messages-disable') ) {
						$elementForInsert.addClass('loading-spiner');
					}
				},
				success: function(msg) {
					foodly.updateDropdownCart();

					// The message when product successfully added to cart
					if ( !$form.hasClass('js-messages-disable') ) {
						
						var $formMessage = $form.find('.form-cart-message');

						// Show message
						if ( $formMessage.length > 0 && $formMessage.hasClass('hide-message') ) {
							$formMessage.removeClass('hide-message hide').addClass('show-message');
						} else {
							$formMessage = $('<p/>').addClass('form-cart-message show-message').html('<span>Hurray!</span> This product was added to cart successfully.');
							$elementForInsert.before($formMessage);
						}

						// Hide message
						setTimeout(function() {
							$formMessage.addClass('hide-message').removeClass('show-message');
							$formMessage.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function addClasses() {
								$formMessage.addClass('hide');
								$formMessage.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', addClasses);
							});
						}, 5000);

						// Hide loading spiner on button
						$elementForInsert.removeClass('loading-spiner');
					}
				},
				error: function(xhr, text) {
					// The error message
					var $formMessage = $form.find('.form-cart-message');

					// Show error message
					if ( $formMessage.length > 0 && $formMessage.hasClass('hide-message') ) {
						$formMessage.removeClass('hide-message hide').addClass('show-message form-cart-message--error');
						$formMessage.text($.parseJSON(xhr.responseText).description);
					} else {
						$formMessage = $('<p/>').addClass('form-cart-message form-cart-message--error show-message').text($.parseJSON(xhr.responseText).description);

						$elementForInsert.before($formMessage);
					}

					// Hide error message
					setTimeout(function() {
						$formMessage.addClass('hide-message').removeClass('show-message');
						$formMessage.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function addClasses() {
							$formMessage.addClass('hide');
							$formMessage.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', addClasses);
						});
					}, 7000);

					// Hide loading spiner on button
					$elementForInsert.removeClass('loading-spiner');
				}
			});
		},

		// Update shopping cart using Shopify object
		updateDropdownCart: function() {

			Shopify.getCart(function(cart) {
				this.doUpdateDropdownCart(cart, false);

        
          if ( cart.item_count > 0 && $('body')[0].classList.contains('template-collection')) {
            this.updateForms(cart, false);
          }
        
              
			}.bind(this));
		},
      
    updateForms: function(cart, removeItemId){
      var $forms = $('.js-form-cart-alt');
      
      if (!cart || $forms.length <= 0 ) {
        return null;
      }
      
      var variantId, $productVisual, $quantityCounter;
              
      for (var i = 0, maxI = $forms.length; i < maxI; i++) {
        variantId = $($forms[i]).find('input[name=id]').val();
        
        $productVisual   = $($forms[i]).closest('.product__visuals');
        $quantityCounter = $($forms[i]).find('.quantity__counter');
                
        for (var j = 0, maxJ = cart.items.length; j < maxJ; j++) {
          if (removeItemId[0] && removeItemId[0] == variantId && $productVisual.hasClass('product-in-cart') ) {
            
            $quantityCounter.text('1');
            $productVisual.removeClass('product-in-cart');
          } else if ( removeItemId[0] && removeItemId[0] == cart.items[j].id ) {

            continue;
          } else if ( variantId == cart.items[j].id ) {
            
            $quantityCounter.text(cart.items[j].quantity);
            $productVisual.addClass('product-in-cart');
          }
        }
      }
    },

		// Update shopping cart items
		doUpdateDropdownCart: function(cart, removeItem) {

			// Template for special packaging
			var specialPackTemplate = '<div class="cart-list__item cart-list__item--special" id="product-id-{ID}"><div class="cart-list__item--img clearfix"><div class="img-holder img-holder--circle img-holder--circle-sm"><img src="{IMAGE}" alt="{TITLE}"></div></div><div class="cart-list__item--title">{TITLE}</div><div class="cart-list__item--quantity-special"></div><div class="cart-list__item--price"><span class="money">{PRICE}</span></div><div class="cart-list__item--remove"><a href="javascript:void(0)" class="js-cart-item-remove"></a></div></div>';

			var specialPack = false;
			var specialPackID = this.cache.$cart.find('.cart-list__item--special').attr('id');
			var $cartContainer = this.cache.$cart.find('.cart');
			var $cartForm = $cartContainer.find('#cart-form');
			var $cartEmpty = $cartContainer.find('.cart-empty');
			var $cartCount = this.cache.$body.find('#cartCount');
			var cartItemFragment = document.createDocumentFragment();

			if ( specialPackID ) {
				specialPackID = specialPackID.match(/\d+/g);
			}

			if ( cart.attributes.special_pack == 'true' ) {
				specialPack = true;
				$cartCount.text(cart.item_count - 1);
			} else {
				$cartCount.text(cart.item_count);
			}

			// The message when cart item has been removed
			if ( removeItem ) {
				this.cartRemoveItemMsg();
			}
			
			// Total of cart
			this.cache.$body.find('.cart-total .money').html(Shopify.formatMoney(cart.total_price, Shopify.money_format));

			// Delete items from cart
			this.cache.$cart.find('.cart-list').html('');

			// Add current products to cart
			if ( cart.item_count > 0 ) {
				var item, specialPackItem;

				// Hide 'Empty cart' message
				$cartEmpty.addClass('display-none');
				// Show table with cart items
				$cartForm.removeClass('display-none');

				for (var i = 0, max = cart.items.length; i < max; i++) {
					
					specialPackItem = specialPackTemplate;

					// If special pack is available in cart - don't show it twice
					if ( specialPackID && specialPackID[0] == cart.items[i].id ) {
						continue;
					}

					// Special packaging
					if ( specialPack && cart.items[i].sku == "0001" ) {
						// Add special packaging into cart
						specialPackItem = specialPackItem.replace(/\{ID\}/g, cart.items[i].id);
						specialPackItem = specialPackItem.replace(/\{TITLE\}/g, cart.items[i].title);
						specialPackItem = specialPackItem.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
						specialPackItem = specialPackItem.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, Shopify.money_format));
						$(specialPackItem).insertAfter(this.cache.$cart.find('.cart__package')); 
						continue;
					} else if ( !specialPack && this.cache.$cart.find('.cart-list__item--special').length > 0 ) {
						// Remove special packaging from cart
						this.cache.$cart.find('.cart-list__item--special').remove();
					}

					item = this.getCartItemDOM(cart.items[i]);
					cartItemFragment.appendChild(item);
				}

				// Insert all cart items into cart list
				this.cache.$cart.find('.cart-list')[0].appendChild(cartItemFragment);

				// Initialization of the dynamic changing quantity for cart items
				this.initChangeQuantity('.cart');

				// Clicking on remove button
				this.cache.$cart.find('.js-cart-item-remove').click( function(e) {
					e.preventDefault();

					var productId = $(e.currentTarget).parents('.cart-list__item').attr('id');

					productId = productId.match(/\d+/g);
					
            this.updateForms(cart, productId);
          
					Shopify.removeItem(productId, function(cart) {
						this.doUpdateDropdownCart(cart, true);
					}.bind(this));

					this.initChangeQuantity('.cart');
				}.bind(this));

			} else {
				// If cart is empty
				$cartForm.addClass('display-none');
				$cartEmpty.removeClass('display-none');
			}

			
		},

		getCartItemDOM: function(cartItem) {
			var template = '<div class="cart-list__item--img clearfix"><div class="img-holder img-holder--circle img-holder--circle-sm"><a href="{URL}"><img src="{IMAGE}" alt="{TITLE}"></a></div></div>' + 

			'<div class="cart-list__item--title"><a href="{URL}">{TITLE}</a></div>' + 

			'<div class="cart-list__item--quantity"><div class="quantity-field"><span class="icon icon--arrow-up js-up-quantity"></span><input id="updates_{ID}" type="number" name="updates[]" min="1" value="{QUANTITY}" size="5"><span class="icon icon--arrow-down js-down-quantity"></span></div></div>' + 

			'<div class="cart-list__item--price"><span class="money">{PRICE}</span></div>' + 

			'<div class="cart-list__item--remove"><a href="javascript:void(0)" class="js-cart-item-remove"><span class="icon icon--delete"></span></a></div>';

			// Create a LI element - container for cart item layout			
			var itemContainerDOM = document.createElement('li');			
			itemContainerDOM.className = 'cart-list__item';
			if (cartItem.id) {
				itemContainerDOM.id = "product-id-" + cartItem.id;
			}

			if ( cartItem.title.length > 20 ) {
				var truncatedTilte = cartItem.title.substr(0, 17);
				truncatedTilte     = truncatedTilte + '...';
			}

			template = template.replace(/\{URL\}/g, cartItem.url);
			template = template.replace(/\{TITLE\}/g, truncatedTilte || cartItem.title);
			template = template.replace(/\{QUANTITY\}/g, cartItem.quantity);

			if ( cartItem.image == null ) {
				// Item without image
				template = template.replace(/\{IMAGE\}/g, Shopify.resizeImage("//cdn.shopify.com/s/files/1/1820/7241/t/4/assets/img_no_image_sm.jpg?v=87746152287872917571488665768", 'small'));
			} else {
				// Item with image
				template = template.replace(/\{IMAGE\}/g, Shopify.resizeImage(cartItem.image, 'compact'));
			}

			template = template.replace(/\{PRICE\}/g, Shopify.formatMoney(cartItem.price, Shopify.money_format));

			itemContainerDOM.innerHTML = template;

			if (cartItem.properties) {
				var itemProp = cartItem.properties,
						itemPropValue = '', itemPropDOM;
				for (var key in itemProp) {
					itemPropDOM = document.createElement('span');
					itemPropDOM.className   = 'cart-list__item--property';
					itemPropDOM.textContent = key + ': ' + itemProp[key];
					itemContainerDOM.querySelector('.cart-list__item--title').appendChild(itemPropDOM);
				}
			}

			return itemContainerDOM;
		},

		cartRemoveItemMsg: function() {
			var $removeMessage = this.cache.$cart.find('.remove-message'),
			    $cartHeader    = this.cache.$cart.find('.cart-header');

			// Show message
			if ( $removeMessage.length > 0 && $removeMessage.hasClass('hide-message') ) {
				$removeMessage.removeClass('hide-message hide').addClass('show-message');
			} else {
				$removeMessage = $('<div/>').addClass('remove-message show-message');
				$removeMessageText = $('<p/>').text('The item has been removed');
				$removeMessage.append($removeMessageText);
				$cartHeader.after($removeMessage);
			}

			// Hide message
			setTimeout( function() {
				$removeMessage.removeClass('show-message').addClass('hide-message');
				$removeMessage.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function addClasses() {
					$removeMessage.addClass('hide');
					$removeMessage.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', addClasses);
				});
			}, 2500);
		},

		// Dynamic changing quantity
		initChangeQuantity: function(form) {
			var $form = $(form);

			var forms = document.querySelectorAll(form);
	
			if ( forms.length === 0 ){
				return 0;
			}

			var quantityContainer, arrowUp, arrowDown, inputField, inputFieldValue;

			for ( var i = 0, max = forms.length; i < max; i++ ) {
              
        if ( $form[i].classList.contains('js-form-cart-alt') ) {
          continue;
        }

				quantityContainer = $($form[i]).find('.quantity-field');
				arrowUp    = quantityContainer.find('.js-up-quantity');
				arrowDown  = quantityContainer.find('.js-down-quantity');

				arrowUp.click( function(e) {
					e.stopPropagation();
					inputField = $(e.currentTarget).next();
					inputFieldValue = inputField.val();
					inputFieldValue++;
					inputField.val(inputFieldValue);
					inputField.trigger("change");
				});

				arrowDown.click( function(e) {
					inputField = $(e.currentTarget).prev();
					inputFieldValue = inputField.val();

					if ( inputFieldValue == 0 ) {
						inputFieldValue = 0;
					} else {
						inputFieldValue--;
					}

					inputField.val(inputFieldValue);
					inputField.trigger("change");
				});
			}
		},

		// Update cart by clicking on updating button
		initUpdateCartAjax: function() {
			var $updateButton = this.cache.$cart.find('#update-cart');
			var $cartForm = this.cache.$cart.find('form[action="/cart"]');

			$updateButton.on('click', function(e){
				e.preventDefault();

				var $cartItems = $cartForm.find('.cart-list .cart-list__item');
				var updateData = '';
				var productID, productValue, quantityField;

				for ( var i = 0, max = $cartItems.length; i < max; i++ ) {
					productID = $cartItems[i].getAttribute('id');
					productID = productID.match(/\d+/g);

					quantityField = $cartItems[i].querySelector('.quantity-field input');
					productValue = quantityField.value;

					if ( i === max - 1 ) {
						updateData += 'updates[' + productID +']=' + productValue;
					} else {
						updateData += 'updates[' + productID +']=' + productValue + '&';
					}
				}

				$.ajax({
					type: "post",
					url: "/cart/update.js",
					data: updateData,
					dataType: 'json',
					beforeSend: function() {
						if ( !$updateButton.hasClass('updating') ) {
							$updateButton.addClass('updating');
						}
					},
					success: function(msg) {
						foodly.updateDropdownCart();
						$updateButton.removeClass('updating');
					}
				});

			})
		},

		// Show/hide recovery password form
		initRecoverPasswordForm: function(container) {
			var $container = $(container);
	
			if ( $container.length === 0 ){
				return 0;
			}

			var $this = this;

			var recoverPasswordLink = $container.find('.js-forget-password');
			var hideRecoverPasswordLink = $container.find('.js-forget-password-cancel');

			var customerLoginForm = $container.find('.form-wrapper--login');
			var recoverPasswordForm = $container.find('.form-wrapper--recover-password');

			recoverPasswordLink.click( function(e) {
				e.preventDefault();
				$this.showRecoverPasswordForm(customerLoginForm, recoverPasswordForm);
			});

			hideRecoverPasswordLink.click( function(e) {
				e.preventDefault();
				$this.hideRecoverPasswordForm(customerLoginForm, recoverPasswordForm);
			});

			if ( window.location.hash == '#recover' ) {
				$this.showRecoverPasswordForm(customerLoginForm, recoverPasswordForm);
			}
		},

		showRecoverPasswordForm: function(loginForm, recoverForm) {
			loginForm.removeClass('fade-in').addClass('fade-out');

			loginForm.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function showForm() {
				loginForm.addClass('display-none');
				recoverForm.removeClass('fade-out display-none').addClass('fade-in');
				loginForm.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', showForm);
			});
		},

		hideRecoverPasswordForm: function(loginForm, recoverForm) {
			recoverForm.removeClass('fade-in ').addClass('fade-out');

			recoverForm.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function hideForm() {
				recoverForm.addClass('display-none');
				loginForm.removeClass('fade-out display-none').addClass('fade-in');
				recoverForm.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', hideForm);
			});
		},

		// Showing fixed top bar
		showTopBar: function(topBar) {
			var $topBar = $(topBar);
	
			if ( $topBar.length === 0 ){
				return 0;
			}

			var y;

			function checkScroll() {
				y = $(this).scrollTop();

				if ( y > 150 ) {
					$topBar[0].classList.add('show');
				} else {
					$topBar[0].classList.remove('show');
				}
			}

			$(window).scroll( function() {
				window.requestAnimationFrame(checkScroll);
			});
		},

		// Find forms and init custom validation on form sumbit
		initFormsError: function() {
			$this = this;

			$('.form-validation').on('submit', function(e) {
				e.preventDefault();

				var validationStatus;
				validationStatus = $this.formErrorValidation(e.target);

				if ( validationStatus ) {
					$(this).off('submit');
					$(this).submit();
				}

			});
		},

		formErrorValidation: function(form) {
			var $form = $(form);
	
			if ( $form.length === 0 ){
				return 0;
			}

			var $this = this;
			var $inputs = $form.find('[class=form__field], [class*=form__field--textarea]');

			for ( var i = 0, max = $inputs.length; i < max; i++ ) {
				if ( $inputs[i].value === '' ) {
					$($inputs[i]).one('keyup', function() {
						var value = $(this).val();
						if ( value.length > 0 ) {
							$(this).addClass('hide-border');
						}
					});
				}
			}

			// General fields
			var $firstName = $form.find('[name*=first_name]');
			var $lastName = $form.find('[name*=last_name]');
			var $email = $form.find('[name*=email]');
			var $password = $form.find('[name*=password]');
			var $passwordConfirm = $form.find('[name*=\\[password_confirmation\\]]');
			var $message = $form.find('[name*=body]');
			var $fullName = $form.find('[name*=\\[name\\]]');
			var $author = $form.find('[name*=author]');
			var $address1 = $form.find('[name*=address1]');
			var $city = $form.find('[name*=city]');
			var $country = $form.find('#AddressCountryNew');
			var $zip = $form.find('[name*=zip]');

			// Error messages from settings
			var errorMsgName = "<span>Ooops!</span> The name is empty";
			var errorMsgLastName = "<span>Oh!</span> The last name is empty";
			var errorMsgEmail = "<span>Ooops!</span> Please check the email";
			var errorMsgPassword = "<span>Notice.</span> The password must consist min 6 charecter";
			var errorMsgMessage = "<span>Ooops!</span> This field is empty.";
			var errorMsgFullname = "<span>Sorry...</span> Please type fullname";
			var errorMsgAuthor = "<span>Sorry...</span> This field is empty. Please, fill it to complete adding the comment";
			var errorMsgAddress1 = "<span>Sorry...</span> This field is empty. Please, fill it to complete adding the address";
			var errorMsgCity = "<span>Sorry...</span> This field is empty. Please, fill it to complete adding the address";
			var errorMsgCountry = "translation missing: en.general.form_popup_errors.country_html";
			var errorMsgZip = "<span>Oh!</span> This zip code is invalid. Please, add the correct one so we could deliver your purchase right to you.";

			var counter = 0;

			// Erros messages for form validation
			function initErrorMsg(input, msg) {
				
				for ( var i = 0, max = $inputs.length; i < max; i++) {
					if ( input.is($inputs[i]) ) {
						counter = i + 1;
					}
				}

				var $errorMsgContainer = input.parent().prev('.error');
				var counterContainer = $('<span/>').addClass('error__counter');

				input.addClass('field__error');

				if ( $errorMsgContainer.length == 0 ) {
					$errorMsgContainer = $('<div/>').addClass('error show-message');
					var errorMessage = $('<p/>').addClass('error__message').html(msg);
					counterContainer.text(counter);
					counterContainer.appendTo(errorMessage);
					errorMessage.appendTo($errorMsgContainer);

					$('<span/>').addClass('icon icon--close').appendTo($errorMsgContainer).click( function(e) {
						var $targetParent = $(e.target).parent();
						$targetParent.removeClass('show-message').addClass('hide-message');

						$targetParent.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function addClasses() {
							$targetParent.addClass('hide');
							$targetParent.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', addClasses);
						});

						if ( $errorMsgContainer.closest('.modal').length > 0 ) {
							$this.cache.modalScroll.resize();
						}
					});

					input.parent().before($errorMsgContainer);

				} else if ($errorMsgContainer.hasClass('hide-message')) {
					$errorMsgContainer.removeClass('hide hide-message').addClass('show-message');
					$errorMsgContainer.find('.error__counter').text(counter);
				} else {
					$errorMsgContainer.find('.error__counter').text(counter);
				}

				if ( $errorMsgContainer.closest('.modal').length > 0 ) {
					$this.cache.modalScroll.resize();
				}
			}

			if ($firstName.length > 0 && $firstName.val() === "") {
				initErrorMsg($firstName, errorMsgName);
			} else {
				$firstName.removeClass('field__error');
				$firstName.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($lastName.length > 0 && $lastName.val() === "") {
				initErrorMsg($lastName, errorMsgLastName);
			} else {
				$lastName.removeClass('field__error');
				$lastName.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($email.length > 0 ){
				var emailValue = $email.val();
				if ( emailValue.indexOf('@') == -1 || emailValue.indexOf('.') == -1 ) {
					initErrorMsg($email, errorMsgEmail);
				} else {
					$email.removeClass('field__error');
					$email.parent().prev('.error').removeClass('show-message').addClass('hide');
				}
			}

			if ($password.length > 0) {
				var passwordValue = $password.val();
				if ( passwordValue.length < 6 ) {
					initErrorMsg($password, errorMsgPassword);
				} else {
					$password.removeClass('field__error');
					$password.parent().prev('.error').removeClass('show-message').addClass('hide');
				}
			}

			if ($passwordConfirm.length > 0) {
				var passwordValue = $passwordConfirm.val();
				if ( passwordValue.length < 6 ) {
					initErrorMsg($passwordConfirm, errorMsgPassword);
				} else {
					$passwordConfirm.removeClass('field__error');
					$passwordConfirm.parent().prev('.error').removeClass('show-message').addClass('hide');
				}
			}

			if ($message.length > 0 && $message.val() === "") {
				initErrorMsg($message, errorMsgMessage);
			} else {
				$message.removeClass('field__error');
				$message.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($fullName.length > 0 && $fullName.val() === "") {
				initErrorMsg($fullName, errorMsgFullname);
			} else {
				$fullName.removeClass('field__error');
				$fullName.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($author.length > 0 && $author.val() === "") {
				initErrorMsg($author, errorMsgAuthor);
			} else {
				$author.removeClass('field__error');
				$author.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($address1.length > 0 && $address1.val() === "") {
				initErrorMsg($address1, errorMsgAddress1);
			} else {
				$address1.removeClass('field__error');
				$address1.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($city.length > 0 && $city.val() === "") {
				initErrorMsg($city, errorMsgCity);
			} else {
				$city.removeClass('field__error');
				$city.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($country.length > 0 && $country.val() === "---") {
				initErrorMsg($country, errorMsgCountry);
			} else {
				$country.removeClass('field__error');
				$country.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ($zip.length > 0 && $zip.val() === "") {
				initErrorMsg($zip, errorMsgZip);
			} else {
				$zip.removeClass('field__error');
				$zip.parent().prev('.error').removeClass('show-message').addClass('hide');
			}

			if ( $('.field__error').length === 0) {
				return true;
			} else {
				return false;
			}
		},

		// Make dropdown for province selector after changing country selector
		initDropdownAfterChanageSelector: function (select, selectForChange) {
			var $select = $(select);
	
			if ( $select.length === 0 ){
				return 0;
			}

			var $selectForNewDropdown;
			var $this = this;

			$select.change(function(e) {
				$selectForNewDropdown = $(e.target).closest('.form').find(selectForChange);
				$selectForNewDropdown.next('.dropdown').remove();
				setTimeout(function() {
					$this.initDropdownScroll(selectForChange);
				}, 100)
				
			})
		},

		// Make dropdown for select with scroll
		initDropdownScroll: function(selects) {
			var $selects = $(selects);
	
			if ( $selects.length === 0 ){
				return 0;
			}

			$this = this;
			var dropdownListScroll = [];

			for ( var i = 0, max = $selects.length; i < max; i++) {
				
				var $dropdown = $('<div/>').addClass('dropdown dropdown--scroll').click( function(e) {
					$this.dropdownEventsListener(e);
				});

				var $dropdownButton = $('<button/>').addClass('dropdown__button').appendTo($dropdown);
				$('<span/>').addClass('icon').appendTo($dropdown);

				var $dropdownList = $('<ul/>').addClass('dropdown-list');

				for ( var j = 0, maxj = $selects[i].length; j < maxj; j++) {

					if ( j === 0 ) {
						$dropdownButton.text($selects[i][j].textContent);
						$($selects[i][j]).addClass('active');
					};

					$('<li/>').addClass('dropdown-list__item').text($selects[i][j].textContent).attr('data-value', $selects[i][j].value).appendTo($dropdownList);
				}

				var $dropdownListWrapperForIcons = $('<div/>').addClass('dropdown-list-container');
				var $dropdownListWrapper = $('<div/>').addClass('dropdown-list-wrapper');

				$dropdownList.appendTo($dropdownListWrapper);

				$dropdownListWrapper.appendTo($dropdownListWrapperForIcons);
				$dropdownListWrapperForIcons.appendTo($dropdown);
				$dropdown.insertAfter($($selects[i]));
				$($selects[i]).hide();

				// Init scroll
				for ( var k = 0, maxk = $dropdownListWrapper.length; k < maxk; k++ ) {
					dropdownListScroll[k] = global.createScrollbar($dropdownListWrapper[k], {
						touchScrollSpeed: 1,
						preventDefaultScroll: true,
						customThumbHeight: 30
				  });
				}
			}
		},

		// Make dropdown for select without scroll
		initDropdown: function(selects) {
			var $selects = $(selects);
	
			if ( $selects.length === 0 ){
				return 0;
			}

			$this = this;
			var link = location.href;

			for ( var i = 0, max = $selects.length; i < max; i++) {
				
				var $dropdownContainer = $('<div/>').addClass('dropdown').click( function(e) {
					$this.dropdownEventsListener(e);
				});

				var $dropdownButton = $('<button/>').addClass('dropdown__button').appendTo($dropdownContainer);
				$('<span/>').addClass('icon').appendTo($dropdownContainer);

				var $dropdownList = $('<ul/>').addClass('dropdown-list');

				for ( var j = 0, maxj = $selects[i].length; j < maxj; j++) {

					if ( link.indexOf($selects[i][j].value) !=-1) {
						$dropdownButton.text($selects[i][j].textContent);
					} else if ( j === 0 ) {
						$dropdownButton.text($selects[i][j].textContent);
						continue;
					};

					$('<li/>').addClass('dropdown-list__item').text($selects[i][j].textContent).attr('data-value', $selects[i][j].value).appendTo($dropdownList);
				}

				$dropdownList.appendTo($dropdownContainer);
				$dropdownContainer.insertAfter($($selects[i]));
				$($selects[i]).hide();
			}
		},

		// Event listeners for dropdowns (open dropdown, select dropdown item)
		dropdownEventsListener: function(e) {
			e.preventDefault();

			var $target = $(e.target);
			var $parentDropdown = $target.closest('.dropdown');
			var $buttonDropdown = $parentDropdown.find('button.dropdown__button');
			var $currentSelect;
			var $currencyButtons, $currencyWrapers;
			var mobileMenuDrawer;
			var currentOpen = false;
			if ( $parentDropdown.hasClass('open') ) {
				currentOpen = true;
			}

			// Open dropdown
			if ( $target.hasClass('dropdown__button') || $target.hasClass('icon') ) {
				$target.closest('.collection__filters').find('.dropdown.open').removeClass('open');
				$target.closest('.shipping-calculator__container').find('.dropdown.open').removeClass('open');

				if ( currentOpen ) {
					$parentDropdown.removeClass('open');
				} else {
					$parentDropdown.addClass('open');
				}

				if ("createEvent" in document) {
					var evt = document.createEvent("HTMLEvents");
					evt.initEvent("resize", false, true);
					window.dispatchEvent(evt);
				} else {
					window.fireEvent("onresize");
				}
			};

			// Click on dropdown items
			if ( $target.hasClass('dropdown-list__item') ) {
				$currentSelect = $parentDropdown.prev('[class*="js-dropdown"]');
				$currentSelect.val($target.attr('data-value'));

				if ("createEvent" in document) {
					var evt = document.createEvent("HTMLEvents");
					evt.initEvent("change", false, true);
					$currentSelect[0].dispatchEvent(evt);
				} else {
					$currentSelect[0].fireEvent("onchange");
				}

				$currencyWrapers = $('.search-container .currency-picker__wrapper');

        if ( $currencyWrapers.length > 0 && $target.closest('.nav-list__item--currency').length > 0 ) {
          $currencyButtons = $currencyWrapers.find('.dropdown__button');
          $currencyButtons.text($target.text());
        }
        
        $buttonDropdown.text($target.text());

				$parentDropdown.find('.active').removeClass('active');
				$target.addClass('active');
				$parentDropdown.removeClass('open');

				mobileMenuDrawer = $('.drawer--menu.open');
				if ( mobileMenuDrawer.length > 0 ) {
        	mobileMenuDrawer.find('.drawer__btn-close').trigger('click');
        }
			}
		},

		// Make currency dropdown in the header
		initCurrencyDropdown: function(select) {
			var $select = $(select);
	
			if ( $select.length === 0 ){
				return 0;
			}

			$select.hide();

			$this = this;
			var link = location.href;
			
			var $dropdownContainer = $('<div/>').addClass('dropdown').click( function(e) {
				$this.dropdownEventsListener(e);
			});

			var $dropdownButton = $('<button/>').addClass('dropdown__button').appendTo($dropdownContainer);
			$('<span/>').addClass('icon').appendTo($dropdownContainer);

			var $dropdownList = $('<ul/>').addClass('dropdown-list');

			for ( var i = 0, max = $select[0].length; i < max; i++) {

				if ( Currency.currentCurrency !== '' && i === 0 ) {
					$dropdownButton.text(Currency.currentCurrency);
				} else if ( i === 0 ) {
					$dropdownButton.text($select[0][i].textContent);
				};

				$('<li/>').addClass('dropdown-list__item').text($select[0][i].textContent).attr('data-value', $select[0][i].value).appendTo($dropdownList);
			}

			$dropdownList.appendTo($dropdownContainer);
			$dropdownContainer.insertAfter($select);
		},

		// For elements that is folded (for example on product page, mobile view)
		foldElements: function(element) {
			var $foldContainers = $(element);
	
			if ( $foldContainers.length === 0 ){
				return 0;
			}

			var $foldToggle = $foldContainers.find('.fold__toggle');
			$foldToggle.click(function(e) {
				var $foldElement = $(e.target).closest('.fold')
				$foldElement.toggleClass('open');

				if ( $foldElement.find('.swiper-container').length > 0 ) {
					global.similarProducts.update();
				}
			});
		},

		// Modal window for addresses
		initModalAddresses: function() {
			var $this = this;
			var $newAddressBtn = $('.js-add-address');
			var $editAddressBtns = $('.js-edit-address');
			var $deleteAddressBtns = $('.js-delete-address');
			
			$newAddressBtn.click( function(e) {
				e.preventDefault();
				$this.toggleAddressForm('#AddAddress');
				$this.disableScroll();
			});

			$editAddressBtns.click( function(e) {
				e.preventDefault();
				var addressID = $(this).attr('data-address-id');
				addressID = '#EditAddress_' + addressID;
				$this.toggleAddressForm(addressID);
				$this.disableScroll();
			});

			$deleteAddressBtns.click( function(e) {
				e.preventDefault();
				var addressID = $(this).attr('data-address-id');
				addressID = '.js-delete-address_' + addressID;
				$this.toggleAddressForm(addressID);
				$this.disableScroll();
			})
		},

		// Show/hide modal window for addresses
		toggleAddressForm: function(container) {
			var $modalContainer = $(container);
	
			if ( $modalContainer.length === 0 ){
				return 0;
			}

			var $this = this;
			var $closeBtn = $modalContainer.find('.js-modal__btn-close');
			var $modalBody = $modalContainer.find('.modal__body');
			var $deleteBtnConfirm = $modalContainer.find('.js-delete-address-confirm');

			this.cache.$body.addClass('modal-open');

			$modalContainer.removeClass('display-none');

			if ( !$modalContainer.find('.modal__body').hasClass('scrollable') && $modalBody.length > 0 ) {
				this.cache.modalScroll = global.createScrollbar($modalBody[0], {
					touchScrollSpeed: 1,
					preventDefaultScroll: true
				});
			}
					
			$closeBtn.click( function(e) {
				e.preventDefault();
				$modalContainer.addClass('display-none');
				$modalContainer.attr('style', '');
				$this.enableScroll();
				$this.cache.$body.removeClass('modal-open');
			});

			// Delete address
			if ( $deleteBtnConfirm.length !== 0 ) {
				$deleteBtnConfirm.click( function(e){
					e.preventDefault();
					var addressID = $(this).attr('data-address-id');
					Shopify.postLink('/account/addresses/' + addressID, {'parameters': {'_method': 'delete'}} );
				});
			}
		},

		// Show hide Google maps on Contact page
		showHideMaps: function(mapsWrapperClass) {
			var $mapsWrapper = $(mapsWrapperClass);
	
			if ( $mapsWrapper.length === 0 ){
				return 0;
			}

			var $btnsOpenMap = $mapsWrapper.find('.js-open-map');
			var $btnCloseMap = $mapsWrapper.find('.js-close-map');

			$btnsOpenMap.click(function() {
				$(this).next().removeClass('elem-hide');
			});

			$btnCloseMap.click(function() {
				$(this).parent().addClass('elem-hide');
			});
		},

		// Toolbar for sorting filters
		initToolbar: function(tollbarClass) {
			var $toolbar = $(tollbarClass);
	
			if ( $toolbar.length === 0 ){
				return 0;
			}

			if ( location.href.indexOf('list') !=-1 ) {
				$toolbar.find('.list-view').addClass('active');
			}
		},

		// Make image as background for covering all container
		coverImg: function (holdersClass) {
			var $imgHolders = $(holdersClass);
	
			if ( $imgHolders.length === 0 ){
				return 0;
			}

			$imgHolders.each( function() {

				var $img = $(this).find('img');
				$img.css('display', 'none');

				$(this).css({
					'background-image': 'url(' + $img.attr('src') + ')',
					'background-repeat': 'no-repeat',
					'background-position': '50% 50%',
					'background-size': 'cover'
				});
			});
		},

		// Initialization of wishlist
		initAddToWishlist: function(wishlistContainer){
			var $wishlistContainer = $(wishlistContainer);
	
			if ( $wishlistContainer.length === 0 ){
				return 0;
			}

			$wishlistContainer.find('#add-to-wish-list').submit(function(e) {
				e.preventDefault();
				var postData = $(this).serializeArray();
				var formURL = $(this).attr("action");
				$.ajax({
					url : formURL,
					type: "POST",
					data : postData,
					success:function(data, textStatus) {
						$wishlistContainer.empty().html('<p>This product is in your <a class="text-link--default" href="/pages/wish-list">wishlist</a></p>');
						// $wishlistContainer.empty().html('<p></p>');
					},
					error: function() {
						$(this).append("<p>I'm afraid that didn't work.</p>");
					}
				});
			});
		},

		// Action for wishlist
		initActionsWishlist: function(wishlistContainer) {
			var $wishlistContainer = $(wishlistContainer);
	
			if ( $wishlistContainer.length === 0 ){
				return 0;
			}

			var $removeButton = $wishlistContainer.find('.js-remove-button');
			var $addToCartButton = $wishlistContainer.find('.js-add-to-cart');
			var $removeForm = $wishlistContainer.find('#remove');
			var $addToCartForm = $wishlistContainer.find('#add-product');
			var $this = this;

			$addToCartButton.on('click', function(e) {
				e.preventDefault();
				variantID = $(this).attr("data-id");
				$addToCartForm.find('#product-select').attr("value", variantID);
				$addToCartForm.submit();
			});

			$removeButton.on('click', function(e) {
				e.preventDefault();
				$this.removeFromWishlist($(this), $removeForm);
			});

		},

		// Remove item fron wishlist
		removeFromWishlist: function ($this, $removeForm) {
			var $elem = $this.closest("tr");
			var tagID = $elem.attr("id");

			$removeForm.find('#remove-value').attr("value", tagID);
			var postData = $removeForm.serializeArray();
			var formURL = $removeForm.attr("action");
			$.ajax({
				url : formURL,
				type: "POST",
				data : postData,
				success:function(data, textStatus) {
					// the message when product successfully added to cart
					var $parentMsg = $elem.closest('.js-wishlist');
					var $message = $parentMsg.find('.remove-message');
					var $table = $parentMsg.find('.table-wrapper');

					if ( $message.length > 0 && $message.hasClass('hide-message') ) {
						$message .removeClass('hide-message hide').addClass('show-message');
					} else {
						$message = $('<p/>').addClass('remove-message show-message').html(' This product has deleted from your wishlist.');
						$table.before($message);
					}

					// delete item
					$elem.remove();

					setTimeout(function() {
						$message.addClass('hide-message').removeClass('show-message');
						$message.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function addClasses() {
							$message.addClass('hide');
							$message.off('webkitAnimationEnd oanimationend msAnimationEnd animationend', addClasses);
						});
					}, 5000);

					if( $(".wishlist__item").length == 0 ) {
						$removeForm.prev('.table-wrapper').hide();
						$removeForm.nextAll('.wishlist-empty').show();
					} 
				},
				error: function() {
					$(this).append("<p>Sorry, something went wrong. Please, try one more time</p>");
					// $(this).append("<p></p>");
				}
			});
		},

		// Fixed header
		fixedHeader: function(fixedHeader) {
			var $fixedHeader = $(fixedHeader);
	
			if ( $fixedHeader.length === 0 || $fixedHeader.hasClass('header--fixed-off') ){
				$('.main-content--top').removeClass('main-content--top');
				return null;
			}

			var y;
			var $this = this;
			var headerHeight  = $fixedHeader.outerHeight();
			var navlistHeight = $fixedHeader.find('.nav-list').outerHeight();
			var refreshY = $(window).scrollTop();

			var drawerIsOpen = false;

			if ( refreshY > navlistHeight ) {
				checkScrollHeader();
			}

			document.body.addEventListener('drawer-open', function() {
				drawerIsOpen = true;
			}.bind(this));

			document.body.addEventListener('drawer-closed', function() {
				drawerIsOpen = false;
			}.bind(this));

			function checkScrollHeader() {

				if (drawerIsOpen) {
					return null;
				}

				y = $(window).scrollTop();

				if ( y > 0 && !$fixedHeader.hasClass('fixed') ) {
					// fixing header (animation with CSS transition)
					$fixedHeader[0].classList.add('fixed');

				} else if ( y <= 0 && $fixedHeader.hasClass('fixed')) {
					// Unfixing header
					$fixedHeader[0].classList.remove('fixed');
				}
			}

			$(window).scroll( function() {
				window.requestAnimationFrame(checkScrollHeader);
			});
		},


		// Parallax effect for contact page and product page
		parallaxScroll: function(parallaxContainer) {
			var $parallaxContainer = $(parallaxContainer);
	
			if ( $parallaxContainer.length === 0 || $('.header').hasClass('header--fixed-off')){

				$parallaxContainer.find('.parallax__back').removeClass('parallax__back');
				$parallaxContainer.find('.parallax__base').removeClass('parallax__base');

				$(window).scroll(function(e) {
					var y = $(window).scrollTop();
					// Start fade up animation
					if ( y > 200 ) {
						$parallaxContainer.addClass('parallax-move');
					}
				});
				return null;
			}

			var _this = this;
			var $parallaxBack = $parallaxContainer.find('.parallax__back');
			var parallaxBackHeight = $parallaxBack.outerHeight();
			
			var $parallaxBase = $parallaxContainer.find('.parallax__base');
			var $header = this.cache.$body.find('.header');
			var headerHeight = $header.outerHeight();
			var coordsBase = $parallaxBase[0].getBoundingClientRect();

			if ($header.hasClass('header--fixed-off')) {
				headerHeight = 0;
			}

			// for fadeup animation
			var windowBase =( $(window).height() - $(window).height() * 0.04);
			var emptyDiv = $('<div/>').addClass('empty-div').css('height', $parallaxBack.height() );

			if ( $parallaxContainer.parent().hasClass('main-content--top') ) {
      	 $parallaxContainer.parent().css('margin-top', '0px');
      }
			
			$parallaxBase.before(emptyDiv);

			this.setParallaxCoords($parallaxBack, $parallaxBase, $header);
			
			$(window).scroll(function(e) {
				window.requestAnimationFrame(function(){
					if ($this.cache.$body.hasClass('cart-open')) {
						return 0;
					}

					var y = $(window).scrollTop();

					if ( y > 80 && !$header.hasClass('header--clear') ) {
						$parallaxBack.css({
							'transform': 'translate3d(0, 80px, 0)',
							'-webkit-transform': 'translate3d(0, 80px, 0)'
						});
						$parallaxBase.css({
							'transform': 'translate3d(0, -80px, 0)',
							'-webkit-transform': 'translate3d(0, -80px, 0)'
						});
					} else if ( y < 80 && !$header.hasClass('header--clear') ) {
						$parallaxBack.css({
							'transform': 'translate3d(0, 220px, 0)',
							'-webkit-transform': 'translate3d(0, 220px, 0)'
						});
						$parallaxBase.css({
							'transform': 'translate3d(0, 0, 0)',
							'-webkit-transform': 'translate3d(0, 0, 0)',
						});
					}

					// Start fade up animation
					if ( y > 200 ) {
						$parallaxContainer.addClass('parallax-move');
					}
				});
			});
		},

		setParallaxCoords: function ($parallaxBack, $parallaxBase, $header) {
			if ( $header.length === 0 || $parallaxBack.length === 0 || $parallaxBase.length === 0 ){
				return null;
			}

			if ( !$header.hasClass('header--clear') ) {
				$parallaxBack.css({
					'transform': 'translate3d(0, 220px, 0)',
					'-webkit-transform': 'translate3d(0, 220px, 0)'
				});
			}

			setTimeout(function(){
				$parallaxBack.css({
					'transition': 'transform 450ms cubic-bezier(0.50, 0.130, 0.5, 0.87)',
					'-webkit-transition': 'transform 450ms cubic-bezier(0.50, 0.130, 0.5, 0.87)'
				});
			}, 0);

			$parallaxBase.css({
				'transition': 'transform 450ms cubic-bezier(0.50, 0.130, 0.5, 0.87)',
				'-webkit-transition': 'transform 450ms cubic-bezier(0.50, 0.130, 0.5, 0.87)'
			});
		},

		// Disabele/enable browser scroll
		// http://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
		disableScroll: function () {
			if (window.addEventListener) // older FF
				window.addEventListener('DOMMouseScroll', this.preventDefault, false);
			window.onwheel = this.preventDefault; // modern standard
			window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
			window.ontouchmove = this.preventDefault; // mobile
		},

		enableScroll: function () {
			if (window.removeEventListener)
				window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
			window.onmousewheel = document.onmousewheel = null;
			window.onwheel = null;
			window.ontouchmove = null;
		},

		preventDefault: function (e) {
			e = e || window.event;
			if (e.preventDefault)
				e.preventDefault();
			e.returnValue = false;
		},

		initUtils: function (e) {
			this.initCustomEventPolyfill();
		},

		initCustomEventPolyfill: function (e) {

			// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
			if ( typeof window.CustomEvent === "function" ) return false;

		  function CustomEvent ( event, params ) {
		    params = params || { bubbles: false, cancelable: false, detail: undefined };
		    var evt = document.createEvent( 'CustomEvent' );
		    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		    return evt;
		   }

		  CustomEvent.prototype = window.Event.prototype;

		  window.CustomEvent = CustomEvent;
		}
	};

	// Using some function as global
	global.updateCart = foodly.updateDropdownCart;
	global.coverImg = foodly.coverImg;
	global.foodly = foodly;

	return global;
})($, global || {});